<template>
    <div>
        <el-result icon="success" title="正在跳转中..."></el-result>
    </div>
</template>

<script>
    import { parseQuery } from '../../../utils/parsing';
    import { noLanding } from '../../../api/personal';

    export default {
        name: 'noLanding',
        created() {
            if (parseQuery().zcdb_token){
                noLanding(parseQuery().zcdb_token).then(res=>{
                    if (res.code==200){
                        sessionStorage.setItem('token',res.data.token)
                        this.$message.success(res.msg)
                        this.$router.push('index')
                    }else{
                        this.$message.error(res.msg)
                        setTimeout(()=>{
                            this.$router.push('login')
                        },1000)
                    }
                })
            }else {
                this.$router.push('login')
            }
        }
    };
</script>

<style scoped>

</style>
